import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';

import './index.css';
import App from './App';
import { ClaimWorkShop } from './CGModel';
import reportWebVitals from './reportWebVitals';

export const workshop = new ClaimWorkShop();
workshop.loadExample(0);
window.model = workshop;

console.log('App version:', window.VERSION);
console.log('Test env variable: ', process.env);
ReactDOM.render(
  <React.StrictMode>
    <Router>
    <Switch>
        <Route path="/cws/:key" component={App} />
        <Route path="/cws" component={App} />
        <Route path="/:key" component={App} />
        <Route path="/" component={App} />
      </Switch>
    </Router>
  </React.StrictMode>,
  document.getElementById('root')
);

//<App />

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
